import { render, staticRenderFns } from "./ChartPositions.vue?vue&type=template&id=07b1745a&"
import script from "./ChartPositions.vue?vue&type=script&lang=js&"
export * from "./ChartPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports